import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { dataPribadiKey } from "../../queries/DataPribadi/useFetchDataPribadi";
import { fileFotoKey } from "../../queries/DataPribadi/useFetchFotoProfile";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";

export async function addFotoProfile(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);
  const res = await ApiClient.post(`/FotoProfile`, formData);
  return res.data;
}

export const useAddFotoProfile = mutationWrapper(addFotoProfile, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(dataPribadiKey);
    getQueryClient().invalidateQueries(checkProfileKey);
    getQueryClient().invalidateQueries(fileFotoKey);
  },
});
